import { UseQueryResult, useQuery } from 'react-query';
import { fetchFacilitiesByOrg } from 'src/api/facilities';
import { UserStoreObject } from 'src/stores/UserStore';
import { Organization } from 'src/stores/OrgStore';
import { Facility } from 'src/stores/FacilityStore';

export const facilitiesByOrgKey = 'facilitiesByOrg';

export const useFacilitiesByOrg = (orgNmIntrnl: Organization['orgNmIntrnl']): UseQueryResult<Facility[]> => {
    return useQuery({
        queryKey: [facilitiesByOrgKey],
        queryFn: async () => {
            return await fetchFacilitiesByOrg(orgNmIntrnl);
        },
        enabled: UserStoreObject.isGraphiumAdmin(),
        initialData: [],
    });
};
